type EventData = {
  path: string;
  code: string;
  branchID?: string;
  leagueID?: string;
  eventID?: string;
  eventName?: string;
};

export type MessageData =
  | {
      eventType:
        | 'APP_READY'
        | 'BUTTON_REDIRECT'
        | 'LOCATION_CHANGE'
        | 'PLACE_BET_CLICKED_NOT_LOGGED_IN'
        | 'shareBetslip'
        | 'depositClick';
      eventData?: EventData;
    }
  | string;

const URL_PREFIX = '/sports';

const extractRelevantPath = (messageData: MessageData) => {
  if (typeof messageData === 'string') return '';

  const data = messageData.eventData;

  if (typeof data !== 'object') return '';

  const splittledPath = data.path.split('/').filter(Boolean);

  if (splittledPath.length === 2) return URL_PREFIX;

  const mainCatergory = splittledPath.at(2);

  if (mainCatergory?.startsWith('az')) {
    return `${URL_PREFIX}/upcoming`;
  }

  if (
    mainCatergory?.startsWith('live') &&
    !mainCatergory?.startsWith('live-betting')
  ) {
    return `${URL_PREFIX}/live`;
  }

  if (mainCatergory === 'account' || mainCatergory === 'my-bets') {
    const sectionAndToken = splittledPath.at(3);

    if (!sectionAndToken) return '';

    const [section] = sectionAndToken.split('?');

    return `${URL_PREFIX}/${mainCatergory}/${section}`;
  }

  if (mainCatergory === 'sports' || mainCatergory === 'live-betting') {
    const idAndToken = splittledPath.at(3);

    if (!idAndToken) return '';

    const [id] = idAndToken.split('?');

    if (!id) return '';

    const subCategoryAndToken = splittledPath.at(4);

    if (subCategoryAndToken) {
      const [subCategory, queryString] = subCategoryAndToken.split('?');

      if (subCategory === 'category') {
        const leagueID = new URLSearchParams(queryString).get('league');

        if (leagueID) return `${URL_PREFIX}/l-${leagueID}`;
      }
    }

    if (mainCatergory === 'sports') {
      return `/${mainCatergory}/s-${id}`;
    }

    return `${URL_PREFIX}/live-betting/e-${id}`;
  }

  const [, , sports, country, championship, match] = splittledPath;

  const eventId = messageData?.eventData?.eventID || '';

  return `${URL_PREFIX}/${sports}/${country}/${championship}/${match}/e-${eventId}`;
};

export const slugifyPath = (messageData: MessageData) => {
  const relevantPath = extractRelevantPath(messageData);

  const decodedPath = (() => {
    try {
      return decodeURIComponent(relevantPath);
    } catch {
      return relevantPath;
    }
  })();

  return decodedPath
    .normalize('NFD')
    .replace(/[\u0300-\u036F]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9/]+/g, '-')
    .replace(/\/+/g, '/')
    .replace(/^-+|-+$/g, '')
    .replace(/\/-+|-+\//g, '/');
};
